import { useEffect, useState } from "react";

/** The current location hash ("#/jobs/123"), updated on navigation. */
export function useHash(): string {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const on = () => setHash(window.location.hash);
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  return hash;
}

/** Path segments after the route: "#/jobs/123/x" gives ["123", "x"]. */
export const hashParams = (hash: string) => hash.replace(/^#\/?/, "").split("/").slice(1).filter(Boolean);

/** Google Maps search link for an address (opens the Maps app on phones). */
export const mapsUrl = (address: string) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

/** tel: link for an Australian phone number as typed. */
export const telHref = (phone: string) => `tel:${phone.replace(/[^\d+]/g, "")}`;
